import { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesConfig from './Route/Route';
import Lodder from "./Component/Loader";
import useInactivityTimer from "./Route/InavctivityTimer";
import { DataDirtyProvider } from "./Context/DataDirtyContext";
import NotificationProvider from "./Context/NotificationContext";
import { BrandingProvider } from "./Component/Branding/useBrandingContext";
const App = () => {
  useInactivityTimer();
  return (
    <NotificationProvider>
      <DataDirtyProvider>
        <BrandingProvider>
          <Router>
            <Suspense fallback={<Lodder show={true} />}>
              <RoutesConfig />
            </Suspense>
          </Router>
        </BrandingProvider>
      </DataDirtyProvider>
    </NotificationProvider>
  );
}

export default App;
